const TZ = 'America/Sao_Paulo';

export function spNow() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
}

export function getWorkWindow(date = spNow()) {
  const day = date.getDay();
  if (day === 0) return null; // domingo: sem acesso
  const end = day === 6 ? 13 * 60 + 30 : 18 * 60 + 30; // sáb 13:30, seg-sex 18:30
  return { start: 9 * 60, end };
}

export function isWorkTime(now = spNow()) {
  const w = getWorkWindow(now);
  if (!w) return false;
  const mins = now.getHours() * 60 + now.getMinutes();
  return mins >= w.start && mins < w.end;
}

export function minutesUntilClose(now = spNow()) {
  const w = getWorkWindow(now);
  if (!w) return null;
  const mins = now.getHours() * 60 + now.getMinutes();
  const left = w.end - mins;
  return left > 0 ? left : 0;
}

export function closingTimeLabel(now = spNow()) {
  const w = getWorkWindow(now);
  if (!w) return null;
  const h = Math.floor(w.end / 60);
  const m = w.end % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export const SCHEDULE_LINES = ['Segunda a sexta: 09:00 às 18:30', 'Sábado: 09:00 às 13:30'];
